
import actionTypes from "../actionTypes";
import initialState from "./initialState"
import { failure, initial, receive, request } from "./operation"



const reducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      return request(state, action)
    case actionTypes.LOGIN_RECEIVE:
      return receive(state, action)
    case actionTypes.LOGIN_FAILURE:
      return failure(state, action)
    case actionTypes.LOGIN_INITIAL:
      return initial(state, action)
    default:
      return state
  }
}

export default reducer;